<template>
  <div class="app bg-grey-lightest h-screen">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style src="./styles/main.css"></style>
<style src="./styles/custom.css"></style>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.hover-transparent-white {
  opacity: 0.6;
  &:hover {
    opacity: 1;
      background: hsla(0% , 0%, 100%, 0.3);
    }
  }

.svg-shadow {
  filter: drop-shadow( 0px 1px 2px hsla(0, 0%, 0%, 0.2) );
}

.animate {
  transition: all .3s ease-out;
}

.lift {
  transform: perspective(100px) translateZ(1rem);
}
</style>
